<template>
  <v-row class="footer-list" no-gutters>
    <v-col>
      <div class="footer-list__col">
        <p class="footer-title">{{ $t('header_download_app') }}</p>

        <div class="footer-context wd-flex wd-flex-col">
          <v-img class="download-app" max-width="164" cover src="@/assets/images/appdownload/app-store.svg?url" @click="downloadApp('ios')" />
          <v-img class="download-app" max-width="164" cover src="@/assets/images/appdownload/google-play.svg?url" @click="downloadApp('android')" />
        </div>
      </div>
    </v-col>

    <v-col v-for="(menuItem, idx) in menuItems" :key="idx">
      <div class="footer-list__col">
        <p class="footer-title">{{ menuItem.title }}</p>

        <div class="footer-context">
          <a v-for="(subItem, key) in menuItem.subItems" :key="key" class="item-link" :href="subItem.url" target="_blank">
            <p class="link-text mb-0">{{ subItem.title }}</p>
          </a>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import tools from '@/mixin/tools'
import { useDownloadLinks } from '@/composition/useConst'

interface FooterSubItem {
  title: string
  url: string
}

interface FooterMenuItem {
  title: string
  subItems: FooterSubItem[]
}

export default {
  name: 'FooterWeb',
  mixins: [tools],
  props: {
    menuItems: { type: Array as () => FooterMenuItem[], default: () => [] },
  },
  setup() {
    const config = useRuntimeConfig()
    const { iosLink, androidLink } = useDownloadLinks()

    function downloadApp(appType: 'ios' | 'android') {
      let link = `${config.public.BASE_URL}/app`
      if (appType === 'ios') {
        link = iosLink.value
      } else if (appType === 'android') {
        link = androidLink.value
      }
      window.open(link)
    }

    return {
      downloadApp,
    }
  },
}
</script>

<style lang="scss" scoped>
.footer-list {
  margin-bottom: 88px;

  &__col {
    .footer-title {
      margin-bottom: 0;
      padding: 8px 0;
      font-size: 20px;
      font-weight: normal;
      line-height: 28px;
    }
    .footer-context {
      .item-link {
        width: fit-content;
        display: block;
        color: white !important;

        .link-text {
          width: fit-content;
          margin-bottom: 0;
          padding: 8px 0;
          line-height: 24px;
          font-size: 17px;
          font-weight: normal;
        }
      }

      .download-app {
        margin: 4px 0;
        cursor: pointer;
      }
    }
  }
}
</style>
